module.exports = __webpack_public_path__ + "img/staying.8d2cd253.svg";